import ReactGA from 'react-ga';

export var GAInitialized  = false;
export function trackPage(pagePath) {
    if(GAInitialized === false) {
        ReactGA.initialize('UA-151604620-1');
        GAInitialized = true;
    }
    ReactGA.pageview(pagePath);
}


// WEBPACK FOOTER //
// ./src/util/analytics.js